export enum Built {
    Unknown,
    Before1945,
    Between1945and1980,
    Between1980and2000,
    After2000,

}